export function hasReportContent(content) {
  if (typeof content !== 'string') return false;
  const doc = new DOMParser().parseFromString(content, 'text/html');
  return Boolean(doc.body.textContent.replace(/\u00a0/g, ' ').trim() || doc.body.querySelector('img'));
}
export function requireReportContent(content) {
  if (!hasReportContent(content)) throw new Error('No report text was returned. Please try generating again; an empty report has not been saved.');
  return content;
}
